module.exports = __webpack_public_path__ + "img/closebtn.ca4cfe6d.svg";